<template>
	<v-card
		height="100%"
		class="d-flex flex-column"
	>
		<v-card-text class="d-flex flex-column flex-grow-1 flex-shrink-0">
			<v-row>
				<v-col>
					<device-search
						v-model:model-value="device"
					/>
				</v-col>
			</v-row>
			<v-row
				class="d-flex justify-center ma-4"
			>
				<h2
					v-if="expectedDuration"
					class="text-light-green-darken-2"
				>
					{{ expectedDuration.toFixed(2) }} <translate>months</translate>
				</h2>
			</v-row>
			<v-row class="justify-end">
				<v-col
					cols="12"
					md="6"
				>
					<v-btn
						:block="true"
						variant="outlined"
						prepend-icon="$cloudDownload"
						color="primary"
						:disabled="!device"
						@click="getRetention"
					>
						<translate>
							Retention Probabilities
						</translate>
					</v-btn>
				</v-col>
				<v-col
					cols="12"
					md="6"
				>
					<v-btn
						:block="true"
						variant="outlined"
						prepend-icon="$cloudDownload"
						color="primary"
						:disabled="!device"
						@click="getPercentages"
					>
						<translate>
							Active Policies
						</translate>(%)
					</v-btn>
				</v-col>
				<v-col
					cols="12"
					md="6"
				>
					<v-btn
						:block="true"
						variant="outlined"
						prepend-icon="$cloudDownload"
						color="primary"
						:disabled="!device"
						@click="getCancellations"
					>
						<translate>
							Cancelled Policies
						</translate>(%)
					</v-btn>
				</v-col>
				<v-col
					cols="12"
					md="6"
				>
					<v-btn
						:block="true"
						variant="flat"
						prepend-icon="$query"
						color="primary"
						:disabled="!device"
						@click="getDuration"
					>
						<translate>
							Expected Duration
						</translate>
					</v-btn>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import DeviceSearch from './DeviceSearch.vue';
import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'PolicyTransitionsQueries',
	components: {
		DeviceSearch
	},
	data () {
		return {
			device: null,
			expectedDuration: null
		};
	},
	methods: {
		/**
		 * push array data to a CSV and download it
		 *
		 * @param {Array} data
		 * @param {string} fileName
		 */
		downloadCSV (data, fileName) {
			const fileURL = window.URL.createObjectURL(new Blob([data.join('\n'), ]));
			const fileLink = document.createElement('a');

			fileLink.href = fileURL;
			fileLink.setAttribute(
				'download',
				`${fileName}.csv`
			);
			document.body.appendChild(fileLink);

			fileLink.click();
		},

		/**
		 * fetch retention data from API
		 */
		getRetention () {
			axios.get(`/api/v0/policytransitionstatistics/retention/${this.device}`).then(({
				data
			}) => {
				this.downloadCSV(data, `retention_${this.device}`);
			});
		},

		/**
		 * fetch percentages data from API
		 */
		getPercentages () {
			axios.get(`/api/v0/policytransitionstatistics/percentages/${this.device}`).then(({
				data
			}) => {
				this.downloadCSV(data, `percentages_${this.device}`);
			});
		},

		/**
		 * fetch cancellations data from API
		 */
		getCancellations () {
			axios.get(`/api/v0/policytransitionstatistics/cancellations/${this.device}`).then(({
				data
			}) => {
				this.downloadCSV(data, `cancellations_${this.device}`);
			});
		},

		/**
		 * fetch duration data from API
		 */
		getDuration () {
			axios.get(`/api/v0/policytransitionstatistics/duration/${this.device}`).then(({
				data
			}) => {
				this.expectedDuration = data;
			});
		},
	}
};
</script>


<style scoped>

</style>
